import React from 'react';
import { BuildingIcon, StarIcon, MessageSquareIcon, MapPinIcon, PhoneIcon, GlobeIcon, MailIcon, TagsIcon, ClockIcon } from 'lucide-react';
export function DataFieldsSection() {
  return <section className="py-24 bg-slate-50" data-id="element-1263">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1264">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-1265">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6 leading-tight" data-id="element-1266">
            Every data field from{' '}
            <span className="text-blue-600" data-id="element-1267">Google Maps</span>, enriched and
            verified
          </h2>
          <p className="text-xl text-slate-600" data-id="element-1268">
            Our Google Maps scraper extracts 50+ fields per business. From basic
            info to owner contacts — all enriched and ready to export.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-1269">
          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-1270">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-1271">
              <BuildingIcon className="w-6 h-6" data-id="element-1272" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-1273">
              Business Name
            </h3>
            <p className="text-slate-600" data-id="element-1274">
              Exact registered name on Google Maps
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-1275">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-1276">
              <StarIcon className="w-6 h-6" data-id="element-1277" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-1278">Rating</h3>
            <p className="text-slate-600" data-id="element-1279">Average star rating from customers</p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-1280">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-1281">
              <MessageSquareIcon className="w-6 h-6" data-id="element-1282" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-1283">
              Reviews Count
            </h3>
            <p className="text-slate-600" data-id="element-1284">Total number of reviews received</p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-1285">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-1286">
              <MapPinIcon className="w-6 h-6" data-id="element-1287" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-1288">
              Full Address
            </h3>
            <p className="text-slate-600" data-id="element-1289">Street, city, state, and zip code</p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-1290">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-1291">
              <PhoneIcon className="w-6 h-6" data-id="element-1292" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-1293">
              Phone Number
            </h3>
            <p className="text-slate-600" data-id="element-1294">Direct business line for calling</p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-1295">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-1296">
              <GlobeIcon className="w-6 h-6" data-id="element-1297" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-1298">
              Website URL
            </h3>
            <p className="text-slate-600" data-id="element-1299">
              Link to the official business website
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-1300">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-1301">
              <MailIcon className="w-6 h-6" data-id="element-1302" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-1303">
              Email Address
            </h3>
            <p className="text-slate-600" data-id="element-1304">
              Verified contact emails when available
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-1305">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-1306">
              <TagsIcon className="w-6 h-6" data-id="element-1307" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-1308">
              Categories
            </h3>
            <p className="text-slate-600" data-id="element-1309">
              Primary and secondary business types
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-1310">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-1311">
              <ClockIcon className="w-6 h-6" data-id="element-1312" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-1313">
              Operating Hours
            </h3>
            <p className="text-slate-600" data-id="element-1314">Daily open and close times</p>
          </div>
        </div>
      </div>
    </section>;
}